import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { giftcardState } from '../client-state/giftcard-state-context';
import useLocale from '../../../Hooks/use-locale';
import { loadGiftcardUspBannerEntries } from './data-loaders/shop-loader';

const useGiftcardUspBannerEntries = () => {
  const { state } = useContext(giftcardState);
  const { languageAsEnum } = useLocale();

  return useQuery({
    queryKey: ['giftcardUspBannerEntries', state.selectedShopId, languageAsEnum],
    queryFn: () => loadGiftcardUspBannerEntries(state.selectedShopId, languageAsEnum),
    enabled: Boolean(state.selectedShopId),
  });
};

export default useGiftcardUspBannerEntries;
